export default __webpack_public_path__ + "static/media/maxican-tacos.c037cfac.png";